import axios from "@/plugins/http/axios.js";
import config from "@/views/star_assignment/config/star_assignment_api.js";
import configRepor from "@/views/reports/config/reports.js";
import PathUri from "@/utils/path_uri";

const _pathUri = new PathUri(config.port, config.context);
const _pathUriReport = new PathUri(configRepor.port, configRepor.context);

export const service = {
    
  getTypeDocumentStarAssignment: (idGroup, idEmpresa, idUsuario) => {
    return axios({
      method: "get",
      url: `${
        config.baseUrl + _pathUri.generateUri() + idGroup
      }/recognition/core/recognitionAssignmentType`,
      headers: {
        idEmpresa: idEmpresa,
        idUsuario: idUsuario,
      },
    });
  },

  getTypeStar: (idGroup, idEmpresa, idUsuario) => {
    return axios({
      method: "get",
      url: `${
        config.baseUrl + _pathUri.generateUri() + idGroup
      }/shape/allShapeType`,
      headers: {
        idEmpresa: idEmpresa,
        idUsuario: idUsuario,
      },
    });
  },

  getCategoryStarAssignment: (idGroup, idEmpresa, idUsuario) => {
    return axios({
      method: "get",
      url: `${
        config.baseUrl + _pathUri.generateUri() + idGroup
      }/recognition/assignmentParametersGroup`,
      headers: {
        idEmpresa: idEmpresa,
        idUsuario: idUsuario,
      },
    });
  },

  postStarAssignmentAll: ({ idGroup, idEmpresa, idUsuario, data }) => {
    return axios.post(
      `${
        config.baseUrl + _pathUri.generateUri() + idGroup
      }/recognition/core/assign/massRecognize`,
      {
        ...data,
      },
      {
        headers: {
          "Content-Type": "application/json",
          idEmpresa: idEmpresa,
          idUsuario: idUsuario,
        },
      }
    );
  },

  postStarAssignmentInd: ({ idGroup, idEmpresa, idUsuario, data }) => {
    return axios.post(
      `${
        config.baseUrl + _pathUri.generateUri() + idGroup
      }/recognition/core/assign/individualRecognize`,
      {
        ...data,
      },
      {
        headers: {
          "Content-Type": "application/json",
          idEmpresa: idEmpresa,
          idUsuario: idUsuario,
        },
      }
    );
  },

  getCardsList: (idGroup, idEmpresa, idUsuario) => {
    return axios({
      method: "get",
      url: `${
        config.baseUrl + _pathUri.generateUri() + idGroup
      }/recognition/core/categoryList`,
      headers: {
        idEmpresa: idEmpresa,
        idUsuario: idUsuario,
      },
    });
  },

  getAllTemplates: (idGroup, idEmpresa, idUsuario) => {
    return axios({
        method: "get",
        url: `${
          configRepor.baseUrl + _pathUriReport.generateUri() + idGroup
        }/assignment-report/list/reports`,
        headers: {
          idEmpresa: idEmpresa,
          idUsuario: idUsuario,
        },
      });
  },

  scatterStarsTemplates: (idGroup,idEmpresa, idUsuario, document ) => {
    return axios({
        method: 'post',
        url: `${config.baseUrl+_pathUri.generateUri()+idGroup}/recognition/report-assignment`,
        headers:{
            'idEmpresa': idEmpresa,
            'idUsuario': idUsuario 
        },
        data: document,
        redirect: 'follow'
    })
  },

  downloadTemplate: (idGroup,idEmpresa, idUsuario ) => {
    return axios({
      method: "get",
      url: `${configRepor.baseUrl + _pathUriReport.generateUri() + idGroup}/assignment-report/generate/report`, 
      headers: {
        idEmpresa: idEmpresa,
        idUsuario: idUsuario,
      },
    });
  }



};
